import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-form2',
  templateUrl: './view-form2.component.html',
  styleUrls: ['./view-form2.component.css']
})
export class ViewForm2Component implements OnInit {
 title="Form-II: Form for verification of character and antecedents of All Personnel";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/view-form2/view-form2.component.ts